<template>
  <div class="modal to-top" :class="className">
      <div class="modal-background"></div>
      <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ title }}</p>
          </header>
          <section v-html="body" class="modal-card-body" :class="{ 'has-text-centered': centerBody }">
          </section>
          <footer class="modal-card-foot has-text-centered">
            <button v-for="button in buttons" :key="button.id" @click="button.click" class="button" :class="button.className">{{ button.title }}</button>
          </footer>
      </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    className: String,
    centerBody: Boolean,
    title: String,
    body: String,
    buttons: Array
  }
};
</script>